import React, { useEffect, useMemo, useState, createContext, useContext } from 'react';
import { translations, type Lang, type Translation } from './translations';
type Ctx = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: Translation;
};
const LanguageContext = createContext<Ctx | null>(null);
const STORAGE_KEY = 'ferby-lang';
function detectInitialLang(): Lang {
  if (typeof window === 'undefined') return 'en';
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'es') return saved;
  } catch {}
  const browser = (navigator.language || 'en').toLowerCase();
  return browser.startsWith('es') ? 'es' : 'en';
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('en');
  useEffect(() => {
    setLangState(detectInitialLang());
  }, []);
  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang;
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  }, [lang]);
  const value = useMemo<Ctx>(() => ({
    lang,
    setLang: setLangState,
    t: translations[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-475">
      {children}
    </LanguageContext.Provider>;
}
export function useTranslation(): Ctx {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be used inside <LanguageProvider>');
  return ctx;
}